/**
 * Live Boat spatial zones — percent positions on vessel photo / silhouette.
 * Override per vessel via monitoring_config.live_boat.zones
 * VRM embed: monitoring_config.live_boat.vrm_embed_url
 */

/** @typedef {{ id: string, label: string, icon: string, x: number, y: number, w: number, h: number, roles: string[], showFlow?: boolean, hideWhenEmpty?: boolean, explorerCategory?: string }} LiveBoatZone */

/** @type {LiveBoatZone[]} */
export const DEFAULT_LIVE_BOAT_ZONES = [
  {
    id: 'helm',
    label: 'Helm & navigation',
    icon: 'compass',
    x: 72,
    y: 18,
    w: 22,
    h: 24,
    roles: ['navigation'],
    explorerCategory: 'navigation',
  },
  {
    id: 'electrical',
    label: 'Electrical systems',
    icon: 'bolt',
    x: 34,
    y: 38,
    w: 32,
    h: 34,
    roles: [
      'houseBattery',
      'shore',
      'solar',
      'inverter',
      'acLoads',
      'dcLoads',
      'starterBattery',
    ],
    showFlow: true,
    explorerCategory: 'electrical',
  },
  {
    id: 'engines',
    label: 'Propulsion',
    icon: 'engine',
    x: 10,
    y: 52,
    w: 28,
    h: 32,
    roles: ['enginePort', 'engineStarboard'],
    hideWhenEmpty: true,
    explorerCategory: 'propulsion',
  },
  {
    id: 'tanks',
    label: 'Tanks & fluids',
    icon: 'tank',
    x: 68,
    y: 52,
    w: 24,
    h: 30,
    roles: ['freshWater', 'wasteWater'],
    explorerCategory: 'tanks',
  },
];

/**
 * Merge vessel monitoring_config overrides with defaults.
 * @param {object|null|undefined} monitoringConfig
 * @returns {LiveBoatZone[]}
 */
export function resolveLiveBoatZones(monitoringConfig) {
  const custom = monitoringConfig?.live_boat?.zones;
  if (!Array.isArray(custom) || custom.length === 0) {
    return DEFAULT_LIVE_BOAT_ZONES;
  }
  const byId = Object.fromEntries(DEFAULT_LIVE_BOAT_ZONES.map((z) => [z.id, z]));
  return custom.map((z) => ({
    ...byId[z.id],
    ...z,
    roles: z.roles || byId[z.id]?.roles || [],
  }));
}
